import IfShield, { IF_SHIELD_NAVY, IF_SHIELD_WHITE } from './IfShield';

type BrandLogoVariant = 'color' | 'white';

interface BrandLogoProps {
  variant?: BrandLogoVariant;
  className?: string;
  alt?: string;
  /** Kept for callers; the IF shield has no tagline. */
  hideTagline?: boolean;
}

export default function BrandLogo({
  variant = 'color',
  className = '',
  alt = 'Iron Forums',
}: BrandLogoProps) {
  return (
    <IfShield
      className={className}
      color={variant === 'white' ? IF_SHIELD_WHITE : IF_SHIELD_NAVY}
      title={alt}
    />
  );
}
